import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { JobPhaseBumpPhotoCommonDto } from '../../job-phase-bump-photo-common/dtos/job-phase-bump-photo-common.dto';
import { JobPhaseBumpPhotoInterface } from '../interfaces/job-phase-bump-photo.interface';
import { JobPhaseBumpDto } from '../../job-phase-bump/dtos/job-phase-bump.dto';
import { JobPhaseBumpInterface } from '../../job-phase-bump/interfaces/job-phase-bump.interface';

@Exclude()
export class JobPhaseBumpPhotoDto
  extends JobPhaseBumpPhotoCommonDto
  implements JobPhaseBumpPhotoInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase Bump ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseBumpId!: string;

  @ApiPropertyOptional({
    type: () => JobPhaseBumpDto,
    title: 'Job Phase Bump',
    description: 'The Job Phase Bump associated with this Job Phase Bump Photo',
  })
  @Expose()
  jobPhaseBump?: JobPhaseBumpInterface;
}
